// extracted by mini-css-extract-plugin
export default {"assurelyWidget":"styles_assurelyWidget__R+GWv"};